// PLAN.md §3.1 — open-source profanity word list.
//
// Source: a small subset of LDNOOBW (List of Dirty, Naughty, Obscene, and Otherwise
// Bad Words), https://github.com/LDNOOBW/List-of-Dirty-Naughty-Obscene-and-Otherwise-Bad-Words
// (CC-BY-4.0). The full list is ~400 entries; this is a curated subset focused on
// the highest-severity terms in English. Extend with the full list pre-launch.
//
// Match is exact (whole-string equality on lowercase canonical). For substring
// matching, use a stricter check at handle creation (we don't want "scunthorpe"-
// style false positives — handles are short enough that exact match is enough).

const PROFANE_HANDLES: ReadonlySet<string> = new Set([
  'fuck', 'fucker', 'fucking', 'motherfucker', 'fuckhead',
  'shit', 'shithead', 'bullshit',
  'cunt', 'twat',
  'bitch', 'asshole', 'asshat',
  'nigger', 'nigga', 'faggot', 'fag', 'retard', 'retarded',
  'kike', 'spic', 'chink', 'gook', 'wetback',
  'tranny', 'dyke',
  'pussy', 'dick', 'cock', 'prick',
  'whore', 'slut', 'skank',
  'rapist', 'rape',
  'porn', 'pornhub',
  'nazi', 'hitler',
  'kys', 'kms',
])

export function isProfane(canonicalHandle: string): boolean {
  return PROFANE_HANDLES.has(canonicalHandle)
}
